import "./instrument";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { Toaster } from 'react-hot-toast';
import './index.css';
import CreateBackendApp from './containers/CreateBackendApp';
import CreateAppFlow2 from "./containers/CreateAppFlow2";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
        <Route index element={<Navigate replace to="/apps" />} />
          <Route path="apps" element={<h1>All the apps here</h1>} />
          <Route path="apps/new" element={<CreateAppFlow2 />} />
          <Route path="apps/new-backend" element={<CreateBackendApp />} />
        </Route>        
      </Routes>
    </BrowserRouter>
    <Toaster />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
